<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';

// ATTRS
const attrs = useAttrs();

// DATA
const back = computed(() => (attrs.back ? (attrs.back as RouteLocationRaw) : undefined));
</script>
<template>
    <div>
        <CompactHeader :back="back" />
        <div class="flex min-h-[calc(100vh-var(--header-height))] flex-col items-center">
            <main class="flex w-full flex-1 flex-col">
                <slot />
            </main>
            <CompactFooter />
        </div>
    </div>
</template>
